<template>
  <b-card>
    <div class="d-flex justify-content-between align-items-center">
      <h5>Platform Settings</h5>
      <b-button variant="success" :disabled="saving" @click="handleSave">
        <b-spinner v-if="saving" small class="mr-50" />
        <feather-icon v-else icon="SaveIcon" />
        Save Changes</b-button
      >
    </div>
    <div v-if="loading" class="text-center py-3">
      <b-spinner variant="primary" />
    </div>
    <b-form v-else>
      <b-row>
        <b-col cols="12">
          <p class="font-weight-bolder border-bottom">Security Settings</p>
          <b-form-group>
            <label class="font-weight-bold" for="session-timeout"
              >Session Timeout (minutes)</label
            >
            <b-form-input
              id="session-timeout"
              v-model.number="form.sessionTimeout"
              type="number"
              min="1"
              max="1440"
            />
          </b-form-group>


          <div class="section-disabled">
            <b-form-group class="text-muted">
              <label class="font-weight-bolder">Two-Factor Authentication </label>
              <div class="d-flex align-items-center justify-content-between">
                <span>Require 2FA for all users </span>
                <b-form-checkbox v-model="form.requireTwoFactorAuth" switch disabled />
              </div>
            </b-form-group>
          </div>
          <b-form-group class="text-muted">
            <label class="font-weight-bolder">Email Verification </label>
            <div class="d-flex align-items-center justify-content-between">
              <span> Require email verification for new accounts </span>
              <b-form-checkbox v-model="form.requireEmailVerification" switch />
            </div>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BCard,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BFormCheckbox,
  BSpinner,
} from "bootstrap-vue";
import { mapState, mapActions } from "vuex";
import useToastHandler from "@/services/toastHandler";

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BFormCheckbox,
    BSpinner,
  },
  data() {
    return {
      form: {
        sessionTimeout: 30,
        requireTwoFactorAuth: false,
        requireEmailVerification: false,
      },
    };
  },
  computed: {
    ...mapState("settings/platform-settings", ["loading", "saving"]),
  },
  created() {
    this.fetchSettings();
  },
  methods: {
    ...mapActions("settings/platform-settings", [
      "getPlatformSettings",
      "updatePlatformSettings",
    ]),
    async fetchSettings() {
      const data = await this.getPlatformSettings();
      if (data?.value) {
        const v = data.value;
        this.form = {
          sessionTimeout: v.sessionTimeout ?? 30,
          requireTwoFactorAuth: v.requireTwoFactorAuth ?? false,
          requireEmailVerification: v.requireEmailVerification ?? false,
        };
      }
    },
    async handleSave() {
      const result = await this.updatePlatformSettings(this.form);
      if (result) {
        this.showToastSuccess(
          "Settings saved",
          "Platform settings updated successfully."
        );
      }
    },
  },
  setup() {
    const { showToastSuccess } = useToastHandler();
    return { showToastSuccess };
  },
};
</script>

<style scoped>
.section-disabled {
  opacity: 0.45;
  pointer-events: none;
  user-select: none;
}
</style>
